<template>
  <div class="message-detail-table">
    <form class="mt-2">
      <!-- <div class="form-group">
            <label for="companyName">社名</label>
            <input type="text" id="companyName" class="form-control" readonly v-model="message.companyName">
        </div> -->
      <div class="form-group mt-4">
        <label>スカウト形式（必須）</label>
        <div style="flex:7">
          <label class="mr-3"
            ><input
              type="radio"
              name="contactType"
              value="応募案内"
              :disabled="true"
              v-model="message.contact_type"
            />
            応募案内</label
          >
          <label class="mr-3"
            ><input
              type="radio"
              name="contactType"
              value="カジュアル面談"
              :disabled="true"
              v-model="message.contact_type"
            />
            カジュアル面談</label
          >
          <label class="mr-3"
            ><input
              type="radio"
              name="contactType"
              value="面接案内"
              :disabled="true"
              v-model="message.contact_type"
            />
            面接案内</label
          >
          <div class="d-flex flex-column">
            <label class="mr-3">
              <input
                type="radio"
                name="contact_type"
                value="その他通知"
                :disabled="true"
                v-model="message.contact_type"
              />
              通知のみ
              <small class="text-muted d-block mt-1"
                >※求人添付および登録者からの回答受付はできません。</small
              >
            </label>
          </div>
          <!-- <label><input type="radio" name="contact_type" value="その他通知" :disabled="true" v-model="message.contact_type"> その他通知</label> -->
        </div>
      </div>
      <div class="form-group">
        <label for="jobTitle">添付求人</label>
        <input
          type="text"
          id="jobTitle"
          name="jd_title"
          class="form-control"
          v-validate="'required'"
          readonly
          v-model="message.job_title"
        />
      </div>
      <div class="form-group">
        <label for="senderName">差出人名</label>
        <input
          type="text"
          id="senderName"
          name="user_name"
          class="form-control"
          v-validate="'required'"
          readonly
          v-model="message.sender"
        />
      </div>

      <div class="form-group">
        <label for="emailSubject" class="emailSubject">件名（必須）</label>
        <input
          type="text"
          name="emailSubject"
          id="emailSubject"
          class="form-control"
          v-validate="'required'"
          readonly
          v-model="message.subject"
        />
      </div>
      <!-- <div class="form-group">
            <label for="jdInfo">JDすっきり表示</label>
            <div style="flex:3">
              <input type="checkbox" name="displayJdSample" v-model="message.jd_display" class="mr-4" disabled>
            </div>
        </div> -->
      <div class="form-group">
        <label
          for="emailMessage"
          class="emailSubject"
          style="margin-bottom: 80px;"
          >本文（必須</label
        >
        <div
          v-html="sanitizedBody"
          class="message-body form-body"
          v-linkified
          style="max-height: 200px;overflow-y: auto;word-break: break-all;"
        ></div>
      </div>
      <div class="form-group mt-4 mb-0">
        <label>不足書類の提出依頼</label>
        <div style="flex:7">
          <label class="mr-4"
            ><input
              type="checkbox"
              name="fileRequest"
              value="職務経歴書"
              :disabled="true"
              v-model="message.file_upload_request"
            />
            職務経歴書</label
          >
          <label
            ><input
              type="checkbox"
              name="fileRequest"
              value="履歴書"
              :disabled="true"
              v-model="message.file_upload_request"
            />
            キャリア登録情報以外の履歴書</label
          >
        </div>
      </div>
      <p style="margin-left: 135px;font-size: 8px;">
        不足書類の提出依頼をすることで、応募率が下がる可能性があります
      </p>
    </form>
  </div>
</template>

<script>
import DOMPurify from 'dompurify';
export default {
  name: 'MessageDetail',
  props: ['message', 'company'],
  computed: {
    bodyCleanUp() {
      // removes doctype, html, body, head tag.
      let body = this.message.body;
      let modified = body.replace(
        /<(\/?|\!?)(DOCTYPE html|html|head|body)>/gm,
        ''
      );
      modified = modified.replace(/(<html([^>]+)>)/gm, '');
      modified = modified.replace(/(<head>([^>]+)>)/gm, '');
      modified = modified.replace(/(<meta([^>]+)>)/gm, '');
      modified = modified.replace(/(<body([^>]+)>)/gm, '');
      modified = modified.replace(/<[^>]*>/g, '');
      modified = modified.replace(/&nbsp;/g, ' ');
      // modified = modified.replace(/[\n\r]/gm, "");
      // console.log(modified.trim());
      return modified.trim();
    },
    sanitizedBody() {
      let { body } = this.message;
      return DOMPurify.sanitize(body.trim(), { ADD_ATTR: ['target'] });
    },
  },
};
</script>
<style scoped>
.message-detail-table {
  padding: 5px;
  background-color: #ebeff1;
}
.form-group {
  font-size: 10px !important;
}
/* >>>.modal-content{
    background-color: #F2F5F7;
} */
.page-content {
  margin-top: 5px;
}

.ibox {
  /* background: #fff; */
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08); */
}

.ibox-body {
  padding: 15px;
}

.preview-body {
  white-space: pre-line;
}

.text-center {
  text-align: center;
}

.line {
  border-bottom: 2px solid #000;
  width: 95%;
  margin: 0 auto;
}
.title {
  padding: 20px;
  text-align: center;
  /* border-bottom: 0.5px solid gray; */
}

.line1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sent-date {
  margin: 0;
  text-align: right;
}

.line2 {
  text-align: center;
}

.title-1 {
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  margin-right: 80px;
}

.title-2 {
  text-align: center;
  font-size: 20px;
  font-weight: lighter;
}

.message-body {
  height: 372px;
  width: 100%;
  overflow-y: auto;
  flex: 7;
  background-color: #d9d9d9 !important;
}
.form-group {
  display: flex;
  align-items: center;
  margin-bottom: 3px;
  color: #3c3c3c;
  font-size: 14px;
}

.form-body {
  border: 1px solid #ccc;
  padding: 10px;
  text-align: justify;
  background: #ffffff;
}

.form-group label {
  flex: 1.8;
  vertical-align: middle;
}

.form-group input[type='radio'] {
  width: 25px;
  height: 25px;
  vertical-align: middle;
}

.form-group input[type='checkbox'] {
  flex: 3;
  width: 25px;
  height: 25px;
  vertical-align: middle;
}

.form-control {
  flex: 7;
  border: 1px solid #ccc;
  padding: 5px;
  border-radius: 2px;
  background-color: #d9d9d9 !important;
  font-size: 10px !important;
}

#templateChangeButton {
  width: 250px;
  font-size: 18px;
  background: #036d6c !important;
  color: #fff;
  padding: 5px;
  border: 1px solid #036d6c;
  border-radius: 3px;
}

.emailSubject {
  /* border: 1px solid #ccc;
    padding: 3px; */
  /* border-radius: 2px; */
  margin-top: 8px;
  /* text-align: center; */
}
</style>
